import { FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Dashboard } from "../pages/Dashboard/Dashbaord";

export const Main: FC = () => {
  return (
    <Routes>
      <Route path='/' element={<Dashboard />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
